// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_0RwS8","soon-wrap":"soon-wrap_GKzwe","title":"title_2zqGI","msg":"msg_eKab5"};